import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const EmailIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="inherit"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M13.8911 0.0138011C16.4102 0.257686 18.6804 1.09718 20.5939 2.74544C24.0597 5.73162 25.4785 9.52909 24.76 14.0519C23.881 19.5836 18.9977 23.8236 13.3965 23.9935C10.4924 24.0819 7.86861 23.2631 5.57584 21.4707C3.14138 19.5673 1.60534 17.0895 1.1019 14.035C0.921961 12.9429 0.921961 11.5711 0.979014 10.7742C1.16459 8.16922 2.25675 5.89212 4.00971 3.95484C5.86424 1.9047 8.15952 0.628216 10.8899 0.154239C11.7852 -0.0263239 13.656 -0.00876928 13.8911 0.0138011ZM15.6717 14.6952C15.7074 14.7366 15.7331 14.766 15.7582 14.7955C15.7833 14.8256 15.8065 14.8576 15.8328 14.8858C16.6065 15.7171 17.5482 16.0231 18.6391 15.6952C19.7086 15.3742 20.3776 14.6231 20.5174 13.519C20.6409 12.5429 20.6133 11.5491 20.429 10.5748C19.5707 6.03946 14.9494 3.31597 10.5501 4.74731C5.77145 6.30215 3.75893 12.104 6.61345 16.2331C8.39902 18.8162 10.925 19.8951 14.0429 19.5296C15.2171 19.3917 16.2892 18.9409 17.2629 18.2676C17.5732 18.0532 17.7018 17.7296 17.6203 17.3923C17.5431 17.072 17.2604 16.8011 16.9156 16.8049C16.7118 16.8068 16.483 16.8851 16.3099 16.998C15.0767 17.8036 13.7288 18.1491 12.2705 17.9817C8.86673 17.5911 6.50185 14.5265 6.96643 11.141C7.46235 7.52346 11.1313 5.1379 14.624 6.20623C17.693 7.14478 19.3287 9.87078 18.9369 13.3497C18.8729 13.9159 18.2698 14.3059 17.7049 14.2112C17.125 14.114 16.7739 13.6808 16.772 13.0476C16.7695 11.8977 16.7726 10.7479 16.7701 9.59868C16.7689 9.1247 16.5275 8.79994 16.12 8.71906C15.809 8.65762 15.557 8.78301 15.3438 8.99179C13.3977 7.52534 11.0598 8.16421 9.92126 9.62125C8.74071 11.1328 8.85858 13.3059 10.2053 14.6776C11.5344 16.0293 13.9187 16.346 15.6717 14.6952Z"
          fill="inherit"
        />
        <path
          d="M15.1772 11.9786C15.186 13.1999 14.1734 14.2205 12.9459 14.2287C11.7233 14.2368 10.7045 13.2262 10.6963 11.9974C10.6882 10.7748 11.6982 9.756 12.9277 9.74785C14.1502 9.7397 15.1684 10.7491 15.1772 11.9786Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default EmailIcon;
